import { HttpClient } from '@angular/common/http'
import { Injectable, Testability } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { API_STATISTICS_V1 } from 'src/app/app-settings'
import { ApiService } from '../api.service'

@Injectable({
  providedIn: 'root',
})
export class PaymentNotificationService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) {}

  private count = new BehaviorSubject('0')
  currentCount = this.count.asObservable()

  test = new Observable<string>()
  getPaymentErrors(date: string) {
    return this.apiService.get(API_STATISTICS_V1 + `Transaction/payment-errors/${date}`)
  }
}
